import ProductCheckout from "../components/ProductCheckout";
import RobuxCard from "../components/RobuxCard";

const THEME = {
  primary: "#22c55e",
  primaryHover: "#16a34a",
  bg: "#040a04",
};

export default function Robux() {
  return (
    <ProductCheckout
      category="robux"
      theme={THEME}
      title={
        <>
          ROBUX <span style={{ color: THEME.primary }}>ROBLOX</span>
        </>
      }
      subtitle="Recargá Robux a tu cuenta de Roblox al mejor precio en pesos argentinos. Transferí al alias, adjuntá el comprobante y envianos el pedido con el monto por WhatsApp."
      bulletTag="ROBUX · ROBLOX"
      ProductCard={RobuxCard}
    />
  );
}
